import { pdfjs } from 'react-pdf';

// react-pdf uses pdfjs-dist 5.x; worker must match that version. Use unpkg to load it without upgrading app's pdfjs-dist (4.x).
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@5.4.296/build/pdf.worker.min.mjs`;

declare global {
  // eslint-disable-next-line no-var
  var __pdfWorkerSrc: string | undefined;
  interface Window {
    __pdfWorkerSrc?: string;
  }
}

export const configurePdfWorker = (src: string) => {
  (globalThis as typeof globalThis & { __pdfWorkerSrc?: string }).__pdfWorkerSrc = src;
  pdfjs.GlobalWorkerOptions.workerSrc = src;
};
